import axios from '@/plugins/axios';
import { handleMarketplaceUrl } from '@/services/api';

const metricsUrl = handleMarketplaceUrl() + '/api/explore/track-event';

export function useAnalytics() {
    const pageview = (url) => {
        axios.post(metricsUrl, {
            event_name: 'page_view',
            value: window.location.host,
            props: {
                url: url,
            },
        })
    }

    const trackCustomEvent = (url, name, props) => {
        axios.post(metricsUrl, {
            event_name: name,
            value: window.location.host,
            props: props,
        })
    }
    return {
        pageview,
        trackCustomEvent
     }
}
